import { Slider } from "../../components/slider/slider";


export class StructureProgramList {
    defaultOptions = {
        wrapperClass: 'structure__content',
        slideClass: 'card-news--program',
        spaceBetween: 1,
        slidesPerView: 5,
        slidesPerColumn: 1,
        slidesPerGroup: 3,
        initialSlide: 0,
        breakpoints: {
            740: {
                slidesPerView: 2.5,
                slidesPerColumn: 1,
                slidesPerGroup: 2
            }
        },
        navigation: {
            prevEl: '.pagination-control__navigation--prev',
            nextEl: '.pagination-control__navigation--next'
        }
    };

    // staff
    structures = $('.structure--program-list');

    constructor() {
        this.init();
    }

    init() {
        if (!this.structures.length) {
            return;
        }

        this.update();

        $(window).resize(() => {
            this.update();
        });
    }

    update() {
        new Slider(this.structures, this.defaultOptions);
    }
}
